import { FlosIcon, Table } from '@flos/react-ui';

const CoverageTextModalTableCell = ({
    text,
    dataHeader,
    iconProps
}: {
    text: string;
    dataHeader?: string;
    iconProps: React.ComponentProps<typeof FlosIcon>;
}): React.JSX.Element => {
    return (
        <Table.Cell data-header={dataHeader}>
            <div className={'u-display-flex u-flex-justify-between u-flex-items-center'}>
                <p className="u-spacing-stack-none">{text}</p>
                <div className="u-spacing-stack-left-3">
                    <FlosIcon {...iconProps} />
                </div>
            </div>
        </Table.Cell>
    );
};

export default CoverageTextModalTableCell;
